import { findUserSavedFilterEqualToDashboardFilterFunction } from '../../../services/utilities/utilities';
import { getFeatureInfoForViewPort, getFeatureInfoForBBox, layerFeaturesCanBePaged } from '../../../services/map/feature/selection';

export const actions = {
    // updates filters in a layer
    // if filters is passed, only those filters are set on attached layers
    // else a layer can be passed and those filters defined in usermap will be updated on the layer
    //      see addLayer in NedGlobe.Frontend/src/store/geo/layers/actions.js
    // otherwise all filters from usermap and dashboard will be (re)applied
    setFilters(store, { filters, updateMap = true, layer }) {
        const getFiltersByLayer = (_layer, filtersUserMap) => {
            const layerData = _layer.layerData || _layer.extended;
            const layerId = layerData.customId || layerData.id;
            // get invisible filters again from dashboard, because invisible filter in usermap can be outdated
            const layerFiltersUserMap = filtersUserMap.filter((userMapLayer) => userMapLayer.layerId === layerId && userMapLayer.filter.visible);

            const activeFilters = _layer.filters.data
                .map(({ settings }) => settings)
                // ignore filters set in dashboard that have been set by the user
                .filter(layerFilter => !findUserSavedFilterEqualToDashboardFilterFunction(layerFiltersUserMap)(layerFilter))
                .map(filterSettings => {
                    return {
                        themeId: layerData.themeId,
                        layerId,
                        filterId: filterSettings.id,
                        filter: filterSettings,
                        layerVisible: layerData.visible
                    };
                });
            // usermap is leading (usermap contains only selected filters, do not add selected filters from dashboard, only if there invisible)
            if (layerFiltersUserMap.length > 0) {
                activeFilters
                    .map(({ filter }) => {
                        filter.selected = filter.visible ? false : filter.selected;
                    });
            }
            return [...layerFiltersUserMap, ...activeFilters];
        };

        let filtersToSet = filters || [];
        if (!filters) {
            // select filters in usermap or use an empty array
            const userMapFilters = store.getters.getActiveUserMap?.content?.filters || []
                // only use filters that are activated
                .filter(filter => filter?.filter?.selected === true);

            if (layer) {
                // use layer to set active filters
                filtersToSet = getFiltersByLayer(layer, userMapFilters);
            } else {
                // if there is no layer passed to set active filters, we recompile from original settings from dashboard
                filtersToSet = store.getters.getActivatedLayers.flatMap(activatedLayer => getFiltersByLayer(activatedLayer, userMapFilters));
            }
        }

        filtersToSet.forEach(filterObject => {
            store.commit('SET_FILTER', { layerId: filterObject.layerId, filter: filterObject });
        });

        if (updateMap) {
            const layers = [...filtersToSet
                .reduce((layerList, filter) => {
                    layerList.add({
                        layerId: filter.layerId,
                        visible: filter.layerVisible,
                    });
                    return layerList;
                }, new Set())
            ];
            layers.forEach(_layer => {
                const layerVisible = _layer.visible === undefined ? true : _layer.visible;
                if (layerVisible) {
                    store.dispatch('updateLayerOnMap', { id: _layer.layerId });
                }
            });
        }
    },
    async AddSelectionFromFilters(store, { filters, expand }) {
        const map = store.state.defaultMap.map;
        // create a list of layer-id's to select features based on filters
        const activeLayersWithFilters = [
            // copy values of set to array
            ...filters
                // only use layers with selected filters
                .filter(filterObject => filterObject.filter.selected)
                // use set to create a list of unique layer-id's
                .reduce((collection, item) => {
                    collection.add(item.layerId);
                    return collection;
                }, new Set())
        ];
        if (activeLayersWithFilters.length > 0) {
            let featureResults = await Promise.all(activeLayersWithFilters.map(layerId => {
                const layerData = store.getters.getLayerById(layerId);
                return getFeatureInfoForViewPort(store, map, layerData, store.state.userData.maxFeatures);
            }));
            if (expand && !featureResults.flatMap(result => result).length > 0) {
                featureResults = await Promise.all(activeLayersWithFilters.map(layerId => {
                    const layerData = store.getters.getLayerById(layerId);
                    return getFeatureInfoForBBox(store, map, layerData, store.getters.getOrganizationBBox, store.state.userData.maxFeatures);
                }));
            }
            return activeLayersWithFilters
                .map((layerId, index) => {
                    const layer = store.getters.getLayerById(layerId);
                    const olLayer = store.getters.getMapLayer(null, layerId).olLayer;
                    let meta;
                    if (layer.type === 'theme') {
                        const theme = store.getters.getThemeById(layer.data.themeId);
                        meta = {
                            type: layer.type,
                            theme
                        };
                    }
                    return {
                        olLayer,
                        layer,
                        features: featureResults[index],
                        meta,
                        limitedResults: !layerFeaturesCanBePaged(layer) && featureResults[index].length > store.state.userData.maxFeatures
                    };
                });
        }
        return null;
    }
};
